import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'

const useStyles = makeStyles((theme) => ({
    tab: {
        [theme.breakpoints.down('sm')]: {},
        [theme.breakpoints.up('md')]: {
            marginLeft: 50,
            marginRight: 50,
        },
        [theme.breakpoints.up('lg')]: {
            marginLeft: 150,
            marginRight: 150,
        },
    },
    tab_1: {
        [theme.breakpoints.down('sm')]: {},
        [theme.breakpoints.up('lg')]: {
            marginLeft: 100,
            marginRight: 100,
        },
        [theme.breakpoints.up('lg')]: {
            marginLeft: 120,
            marginRight: 120,
        },
    },
}))

export default function TabPanel(props) {
    const classes = useStyles()
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box
                    p={3}
                    className={index === 4 ? classes.tab_1 : classes.tab}
                >
                    {children}
                </Box>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}
